module.exports = __webpack_public_path__ + "img/planning.75829a90.svg";